import { jobPositionCategory } from '@/api/common/master-lists'

export default {
  namespaced: true,
  state () {
    return {
      loading: false,
      items: sessionStorage.getItem('jobPositionCategories')
        ? JSON.parse(sessionStorage.getItem('jobPositionCategories'))
        : []
    }
  },
  mutations: {
    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    },
    /**
     * Set the status.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_LOADING (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    /**
     * Fetch all JobPositionCategory records.
     *
     * @param { commit, dispatch, state}
     */
    fetch ({ commit, dispatch, state }) {
      if (state.items.length) return

      commit('SET_LOADING', true)

      return jobPositionCategory.index()
        .then(({ data }) => {
          commit('SET_ITEMS', data)

          sessionStorage.setItem('jobPositionCategories', JSON.stringify(data))
        })
        .catch(({ response }) => {
          dispatch('httpException/handle', response, { root: true })
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    }
  }
}
